import { Box, TableCell, TableRow } from '@mui/material';
import { FC, useContext } from 'react';

import { ReactComponent as EditIcon } from '../../../../assets/images/highlight.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/images/DeleteIcon.svg';
import ActionToolTip from '../../../../components/formlib/ActionToolTip';
import TooltipTableCell from '../../../../components/formlib/TooltipTableCell';
import { EmployeeListType } from '../../../../services/ifspClient/IfspApi';
import { formatName } from '../../../../utils/nameUtils';
import { LookUpContext } from '../../../../context/LookUpContextProvider';
import { EvaluationTeamMemberType } from '../../../../redux/features/ifsp/ifspHealthSummarySlice';

interface EvaluationTableRowType {
  data: EvaluationTeamMemberType;
  employeeList: EmployeeListType[];
  onEdit: (data: EvaluationTeamMemberType) => void;
  onDelete: (data: EvaluationTeamMemberType) => void;
}

const HealthEligibilityTableRow: FC<EvaluationTableRowType> = ({
  data,
  employeeList,
  onEdit,
  onDelete,
}) => {
  const { lookups } = useContext(LookUpContext);
  const handleEdit = () => {
    onEdit(data);
  };

  const handleDelete = () => {
    onDelete(data);
  };

  return (
    <TableRow>
      <TableCell>
        <TooltipTableCell
          value={formatName(
            employeeList.find((x) => x.id === data.teamMemberId)?.firstName ??
              '',
            null,
            employeeList.find((x) => x.id === data.teamMemberId)?.lastName ??
              '',
            null,
          )}
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
          textSxProps={{
            maxWidth: '200px',
          }}
        />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={
            lookups?.employeeDiscipline?.find(
              (d) => d.code === data.teamMemberDiscipline,
            )?.description || ''
          }
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
          textSxProps={{
            maxWidth: '200px',
          }}
        />
      </TableCell>
      <TableCell>
        <Box className="flex__">
          <Box
            component="div"
            className="cursor__pointer pointerEvents mr-md"
            onClick={handleEdit}
          >
            <ActionToolTip labelId="BlockTime.edit" defaultLabel="Edit">
              <EditIcon />
            </ActionToolTip>
          </Box>
          <Box
            component="div"
            className="cursor__pointer"
            onClick={handleDelete}
          >
            <ActionToolTip
              labelId="ConsentForms.listActionDeleteToolTipLabel"
              defaultLabel="Delete"
            >
              <DeleteIcon />
            </ActionToolTip>
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default HealthEligibilityTableRow;
